import { jsx } from "react/jsx-runtime";
import { useTheme } from "@mui/material";
import { Children, forwardRef, useCallback, useMemo } from "react";
import { useWindowSize } from "../../../hooks/index.js";
import { VirtualList } from "../../VirtualList/index.js";
import { useMultiSelectState } from "../hooks/useMultiSelectState.js";
import { getVerticalPaddingByDensity } from "../utils/getVerticalPaddingByDensity.js";
const updateScrollModeOnDataChange = {
  addedAtTop: true,
  removedFromTop: true,
  addedAtBottom: true,
  removedFromBottom: true
};
function RenderItem({ item }) {
  return item;
}
const VirtualListboxComponent = forwardRef(
  function VirtualListboxComponent2(props, ref) {
    const { children, ...other } = props;
    const theme = useTheme();
    const {
      getItemHeights: providedGetItemHeights,
      buffer,
      props: { density = "normal" }
    } = useMultiSelectState();
    const { height: windowHeight } = useWindowSize();
    const getItemHeights = useCallback(
      (item, index, items2) => {
        const itemHeight = providedGetItemHeights(item, index, items2);
        const verticalPadding = Number.parseInt(theme.spacing(getVerticalPaddingByDensity(density)).replace("px", ""));
        return itemHeight + verticalPadding * 2;
      },
      [providedGetItemHeights, density, theme]
    );
    const { listHeight, items } = useMemo(() => {
      const childrenArray = Children.toArray(children);
      const { totalItemHeight, items: items2 } = childrenArray.reduce(
        (acc, option, index) => {
          acc.totalItemHeight += getItemHeights(option, index, childrenArray);
          acc.items.push({ ...option, id: option.key });
          return acc;
        },
        { totalItemHeight: 0, items: [] }
      );
      const maxListHeight = windowHeight * 0.4;
      const listHeight2 = totalItemHeight > maxListHeight ? maxListHeight : totalItemHeight;
      return { listHeight: listHeight2, items: items2 };
    }, [getItemHeights, windowHeight, children]);
    return /* @__PURE__ */ jsx("div", { ref, ...other, children: /* @__PURE__ */ jsx(
      VirtualList,
      {
        items,
        buffer,
        listHeight,
        RenderItem,
        getItemHeights,
        updateScrollModeOnDataChange
      }
    ) });
  }
);
export {
  VirtualListboxComponent
};
//# sourceMappingURL=VirtualListboxComponent.js.map
